/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import { useEffect } from 'react'
import { usePagination, useRowSelect, useSortBy, useTable } from 'react-table'
import CN from 'classnames'

import { CheckBox } from 'components/atoms/Checkbox'
import { QuantityPicker } from 'components/atoms/QuantityPicker'

const Table = ({
  columns,
  data,
  selectedTableRows,
  setSelectedRows,
  selectedOriginalRowIds,
  isBulkSlip,
}) => {
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    page,
    toggleAllRowsSelected,
    toggleRowSelected,
    selectedFlatRows,
  } = useTable(
    {
      columns,
      data,
      initialState: {
        pageSize: 30,
        pageIndex: 0,
        selectedRowIds: selectedTableRows || [],
      },
      manualPagination: true,
      manualSortBy: false,
      autoResetPage: false,
      autoResetSelectedRows: false,
      disableSortBy: false,
    },
    useSortBy,
    usePagination,
    useRowSelect,
    (hooks) => {
      hooks.visibleColumns.push((cols) => [
        {
          id: 'selection',
          customWidth: 32,
          Header: ({ getToggleAllPageRowsSelectedProps }) => (
            <CheckBox
              {...getToggleAllPageRowsSelectedProps()}
              disabled={isBulkSlip}
            />
          ),
          Cell: ({ row }) => (
            <CheckBox
              {...row.getToggleRowSelectedProps()}
              disabled={isBulkSlip}
            />
          ),
        },
        ...cols,
      ])
    },
  )

  useEffect(() => {
    if (data?.length > 0 && selectedOriginalRowIds?.length > 0) {
      const selectedRows = data.map((item, idx) => {
        if (selectedOriginalRowIds.includes(item.id)) {
          toggleRowSelected(idx.toString(), true)
          return idx
        }
        return null
      })
    }
  }, [selectedOriginalRowIds, data])

  const slicedPageData = page

  useEffect(() => {
    const selectedRows = selectedFlatRows.map((row) => row.original)
    setSelectedRows(selectedRows)
  }, [selectedFlatRows])

  return (
    <>
      <div className='styled-scroll h-full relative overflow-y-auto rounded border border-N-200'>
        <table className='w-full overflow-y-auto' {...getTableProps()}>
          <thead>
            {headerGroups.map((headerGroup) => (
              <tr {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map((column) => (
                  <th
                    {...column.getHeaderProps(column.getSortByToggleProps())}
                    className={CN(
                      'bg-N-100 border-b border-b-N-200 sticky top-0 shadow-sm text-left pl-4 z-[1]',
                      {
                        'bg-N-200': column.isSorted,
                      },
                    )}
                    style={{ height: 40 }}
                    width={column.customWidth}>
                    <div
                      className='inline-flex items-center'
                      style={{ minHeight: 20 }}>
                      {column.render('Header')}
                      <span className='flex ml-1' style={{ width: 14 }}>
                        {column.isSorted &&
                          (column.isSortedDesc ? (
                            <i className='ri-arrow-up-s-line' />
                          ) : (
                            <i className='ri-arrow-down-s-line' />
                          ))}
                      </span>
                    </div>
                  </th>
                ))}
              </tr>
            ))}
          </thead>
          <tbody {...getTableBodyProps()}>
            {slicedPageData.map((row) => {
              prepareRow(row)
              return (
                <tr
                  className={CN('h-11  cursor-pointer', {})}
                  {...row.getRowProps()}
                  onClick={() => {
                    //toggleAllRowsSelected(false)
                    !isBulkSlip && row.toggleRowSelected()
                  }}>
                  {row.cells.map((cell) => (
                    <td
                      {...cell.getCellProps()}
                      className={CN(
                        'border-b border-b-N-200 text-sm text-N-700 py-[11px] px-4',
                        {
                          'bg-N-300 border-b border-b-N-400': cell.isSelected,
                        },
                      )}>
                      {cell.column.isAction ? (
                        <div
                          onClick={(e) => {
                            e.stopPropagation()
                          }}
                          className='flex items-center w-fit'></div>
                      ) : (
                        cell.render('Cell')
                      )}
                    </td>
                  ))}
                </tr>
              )
            })}
          </tbody>
        </table>
      </div>
    </>
  )
}

Table.propTypes = {}

export default Table
